import api from '../services/api'
import { RESET } from '../redux/game'
import { setContent } from '../services/translate'

// Actions
const FETCHING_CONTENT_START = 'ascension/content/fetching'
const FETCHING_CONTENT_SUCCESS = 'ascension/content/success'
const FETCHING_CONTENT_ERROR = 'ascension/content/error'

const arrayToObject = (array, key) => {
  if (array === undefined) return {}
  const initialValue = {}
  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item[key]]: item
    }
  }, initialValue)
}

// Reducer
const initialState = {
  isLoading: false,
  isLoaded: false,
  error: null,
  content: {}
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCHING_CONTENT_START: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: null
      }
    }
    case FETCHING_CONTENT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        content: action.data
      }
    }
    case FETCHING_CONTENT_ERROR: {
      return {
        ...state,
        content: {},
        isLoading: false,
        error: action.data
      }
    }
    case RESET: {
      return initialState
    }
    default: return state
  }
}

export default reducer

export function fetchingContentStart () {
  return {
    type: FETCHING_CONTENT_START
  }
}

export function fetchingContentSuccess (content) {
  return {
    type: FETCHING_CONTENT_SUCCESS,
    data: content
  }
}

export function fetchingContentError (error) {
  return {
    type: FETCHING_CONTENT_ERROR,
    data: error
  }
}

// Action Creators
export function fetchContent () {
  return async (dispatch) => {
    dispatch(fetchingContentStart())

    try {
      const response = await api.getContent()
      if (response.summaryScreen && response.summaryScreen.metrics) {
        response.summaryScreen.metrics = arrayToObject(response.summaryScreen.metrics, 'type')
      }
      if (response.ourFinancials && response.ourFinancials.summaryMetrics && response.ourFinancials.summaryMetrics.metrics) {
        response.ourFinancials.summaryMetrics.metrics = arrayToObject(response.ourFinancials.summaryMetrics.metrics, 'type')
      }
      if (response.operatingCosts && response.operatingCosts.businessfunctions) {
        response.operatingCosts.businessfunctions = arrayToObject(response.operatingCosts.businessfunctions, 'type')
      }
      setContent(response)
      dispatch(fetchingContentSuccess(response))
    } catch (e) {
      dispatch(fetchingContentError(e))
    }
  }
}
